export function clone<T extends object>(obj: T) {
  if (!obj) {
    return obj;
  }
  return JSON.parse(JSON.stringify(obj)) as T;
}
